import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import '@fontsource/inter/400'
import '@fontsource/inter/500'
import '@fontsource/inter/600'
import '@fontsource/inter/700'
import '@fontsource/lateef/500'
import '@fontsource/lateef/600'
import '@fontsource/playfair-display/600'

import { store } from 'root-redux/store'

import { initSentry } from 'helpers/initSentry'

import { App } from './App'
import './i18n'
import './styles/rootStyles.css'

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    // Facebook Pixel
    fbq: any
    // TikTok Pixel
    ttq: any
    // Snap Pixel
    snaptr: any
    // Reddit Pixel
    rdt: any
    // AppsFlyer WebSDK
    // Outbrain Pixel
    obApi: any
    // Taboola Pixel
    _tfa: any
    AF: any
    // Google analytics
    gtag: any
    dataLayer: any
    // Applovin
    axon: any
    // Pinterest
    pintrk: any
    MSStream: any
  }
}

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)

window.setTimeout(initSentry, 0)

export { OptionType } from 'root-constants'
